import axios from "axios";
import buildFetchDuck from "../../vendor/signal-utils/build-fetch-duck";
import chainReducers from "../../vendor/signal-utils/chain-reducers";
import apiUrl from "../../api-url";

import { RECEIVE_WATCHLIST } from "../user-data/UserDataState";

// URLS
const BASE_URL = apiUrl("/shipping-ng");
const SHIPMENT_TOTALS_URL = BASE_URL + "/shipments/totals";
const SHIPMENT_DETAILS_URL = BASE_URL + "/shipments/";

const STORE_MOUNT_POINT = "shipmentsStatus";

// Actions
const RECEIVE_SHIPMENT_TOTALS = "shipments/RECEIVE_SHIPMENT_TOTALS";
const RECEIVE_WATCHLIST_ITEM_SHIPMENTS =
  "shipments/RECEIVE_WATCHLIST_ITEM_SHIPMENTS";

const shipmentDetailsDuck = buildFetchDuck("shipmentDetails");

// Fetchers
export const fetchShipmentDetails = shipmentID => {
  const url = SHIPMENT_DETAILS_URL + shipmentID;
  return dispatch => dispatch(shipmentDetailsDuck.fetch(url));
};

export const fetchShipmentTotals = () => {
  return dispatch => {
    return Promise.all([axios.get(`${SHIPMENT_TOTALS_URL}`)])
      .then(responses => {
        dispatch({ type: RECEIVE_SHIPMENT_TOTALS, payload: responses[0].data });
      })
      .catch(err => {
        throw new Error(err);
      });
  };
};

export const fetchShipmentTotalsByPart = part => {
  return dispatch => {
    return Promise.all([axios.get(`${SHIPMENT_TOTALS_URL}?part_values=${part}`)])
      .then(responses => {
        const payload = { item: "PART:" + part, data: responses[0].data };
        dispatch({ type: RECEIVE_WATCHLIST_ITEM_SHIPMENTS, payload: payload });
      })
      .catch(err => {
        console.log(err);
        //throw new Error(err);
      });
  };
};

export const fetchShipmentTotalsByLocation = location => {
  return dispatch => {
    return Promise.all([
      axios.get(`${SHIPMENT_TOTALS_URL}?shipper_location_ids=${location}`)
    ])
      .then(responses => {
        const payload = {
          item: "LOCATION:" + location,
          data: responses[0].data
        };
        dispatch({ type: RECEIVE_WATCHLIST_ITEM_SHIPMENTS, payload: payload });
      })
      .catch(err => {
        throw new Error(err);
      });
  };
};

const initialState = {
  all_shipments: {
    total_shipments: null,
    details: []
  },
  watchlistShipments: []
};

export function getKeyFromSiteAndPart(site, part) {
  if (part && part.length > 0) return "PART:" + part;
  if (site) return "LOCATION:" + site;

  return null;
}
function getKeyForWatchlistObject(watchlistObject) {
  if (watchlistObject.part_value) return "PART:" + watchlistObject.part_value;
  if (watchlistObject.location_id)
    return "LOCATION:" + watchlistObject.location_id;

  return null;
}

function createSummary(apiData) {
  let summaryList = [];
  summaryList.push({ key: "Idle Trailer", count: apiData.total_idle_trailer });
  summaryList.push({ key: "Idle Train", count: apiData.total_idle_train });
  summaryList.push({
    key: "Behind Schedule",
    count: apiData.total_behind_schedule
  });
  summaryList.push({
    key: "Missed Pickup",
    count: apiData.total_missed_pickup
  });
  summaryList.push({
    key: "Missed Drop-off",
    count: apiData.total_missed_dropoff
  });
  summaryList.push({ key: "Bad Order", count: apiData.total_bad_order });
  summaryList.push({ key: "In Hold", count: apiData.total_in_hold });
  summaryList.push({ key: "On Time", count: apiData.total_on_time });

  return { total_shipments: apiData.total_shipments, details: summaryList };
}

function ShipmentsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case RECEIVE_SHIPMENT_TOTALS:
      return {
        ...state,
        all_shipments: createSummary(action.payload)
      };

    case RECEIVE_WATCHLIST:
      let createdWatchlist = [];
      function createWatchlistState(data, index) {
        createdWatchlist.push({
          item: getKeyForWatchlistObject(data),
          data: {
            total_shipments: null,
            details: []
          }
        });
      }

      action.data.forEach(createWatchlistState);
      return {
        ...state,
        watchlistShipments: createdWatchlist
      };

    case RECEIVE_WATCHLIST_ITEM_SHIPMENTS:
      let itemIndex = state.watchlistShipments.findIndex(
        d => d.item === action.payload.item
      );

      return {
        ...state,
        watchlistShipments: [
          ...state.watchlistShipments.slice(0, itemIndex),
          {
            item: action.payload.item,
            data: createSummary(action.payload.data)
          },
          ...state.watchlistShipments.slice(itemIndex + 1)
        ]
      };

    default:
      return state;
  }
}

// selectors
const getShipmentDetails = state => state.shipmentsStatus.data || {};

// interface
const shipmentsStatusState = {
  mountPoint: STORE_MOUNT_POINT,
  actionCreators: {
    fetchShipmentDetails,
    fetchShipmentTotals,
    fetchShipmentTotalsByLocation,
    fetchShipmentTotalsByPart
  },
  selectors: { getShipmentDetails },
  reducer: chainReducers([ShipmentsReducer, shipmentDetailsDuck.reducer])
};
export default shipmentsStatusState;



// WEBPACK FOOTER //
// ./src/modules/shipment-status/ShipmentsState.js